// MB-I18N-1 — Helpers de formatage Intl (préparatoires, non branchés sur les écrans métier).
// Toujours passer la devise en argument ; aucune devise métier codée en dur.

import { resolveLocale } from './resolveLocale';
import { currencySymbol } from '../lib/currency';

const toDate = (value) => (value instanceof Date ? value : new Date(value));

export function formatNumber(value, locale, options = {}) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  try {
    return new Intl.NumberFormat(resolveLocale(locale), options).format(num);
  } catch {
    return String(value);
  }
}

// MB-I18N-3 — Montant localisé (séparateurs Intl selon locale) + symbole d'AFFICHAGE
// métier issu EXCLUSIVEMENT de lib/currency.js. JAMAIS de code ISO dans l'UI commerçant.
// Convention SUPERKAWA conservée : symbole placé APRÈS le montant.
export function formatCurrency(value, currency, locale, options = {}) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  const sym = currencySymbol(currency);
  const formatted = formatNumber(num, locale, options);
  return sym ? `${formatted} ${sym}` : formatted;
}

// MB-I18N-3 — Pourcentage localisé. La valeur est un pourcentage déjà exprimé (ex. 19 → « 19 % »).
export function formatPercent(value, locale, options = { maximumFractionDigits: 2 }) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  return `${formatNumber(num, locale, options)} %`;
}

// MB-I18N-4 — Date + heure localisées (UI). Documents légaux/fiscaux exclus.
export function formatDateTime(value, locale, options = { dateStyle: 'short', timeStyle: 'short' }) {
  return formatDate(value, locale, options);
}

export function formatDate(value, locale, options = {}) {
  const d = toDate(value);
  if (Number.isNaN(d.getTime())) return '';
  try {
    return new Intl.DateTimeFormat(resolveLocale(locale), options).format(d);
  } catch {
    return '';
  }
}

export function formatTime(value, locale, options = { hour: '2-digit', minute: '2-digit' }) {
  const d = toDate(value);
  if (Number.isNaN(d.getTime())) return '';
  try {
    return new Intl.DateTimeFormat(resolveLocale(locale), options).format(d);
  } catch {
    return '';
  }
}

export function formatRelativeTime(value, unit, locale, options = { numeric: 'auto' }) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  try {
    return new Intl.RelativeTimeFormat(resolveLocale(locale), options).format(num, unit);
  } catch {
    return '';
  }
}

export function getPluralCategory(count, locale) {
  const num = Number(count);
  try {
    return new Intl.PluralRules(resolveLocale(locale)).select(Number.isFinite(num) ? num : 0);
  } catch {
    return 'other';
  }
}
